import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppBootstrapModule } from './app-bootstrap.module';
import { RouterModule } from '@angular/router';
import {appRoutes} from './routerConfig';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TopNavComponent } from './components/ui/top-nav/top-nav.component';
import { AppFooterComponent } from './components/ui/app-footer/app-footer.component';
import { ServicesComponent } from './components/services/services.component';
import { CareersComponent } from './components/careers/careers.component';
import { ContactComponent } from './components/contact/contact.component';
import { PolicyComponent } from './components/policy/policy.component';
import { CustomerComponent } from './components/customer/customer.component';
import { CloudComponent } from './components/cloud/cloud.component';
import { EnterpriseComponent } from './components/enterprise/enterprise.component';
import { ChannelComponent } from './components/channel/channel.component';
import { ProgramComponent } from './components/program/program.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    DashboardComponent,
    TopNavComponent,
    AppFooterComponent,
    ServicesComponent,
    CareersComponent,
    ContactComponent,
    PolicyComponent,
    CustomerComponent,
    CloudComponent,
    EnterpriseComponent,
    ChannelComponent,
    ProgramComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes,{useHash:true}),
    AppBootstrapModule 
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/globant/site/src/app/app.module.ts